/**
 * Контракт для нативной обёртки (APK/WebView).
 *
 * Обратный вызов (обёртка → приложение):
 * - triggerBack() — выставляет приложение. Обёртка вызывает его при аппаратной кнопке Back.
 * - backWasHandled — выставляется приложением после triggerBack(): true = приложение обработало
 *   (закрыло карточку/модалку). Обёртка должна прочитать это и НЕ вызывать WebView.goBack()/finish(),
 *   иначе закроется и страница объекта. Вызов: triggerBack(); если bridge.backWasHandled === true — не делать goBack().
 *
 * Перехват нажатия в приложении (приложение → обёртка):
 * - onBackRequest() — инжектирует обёртка; возврат true = обёртка обработала сама.
 */

export const RYASKOV_BACK_REQUEST_EVENT = 'ryaskov-back-request';

export interface RyaskovBackRequestDetail {
  /** Вызвать, чтобы приложение выполнило своё стандартное действие «назад» (после перехвата обёрткой). */
  requestDefault: () => void;
}

export interface RyaskovNativeBridge {
  triggerBack?: () => void;
  /**
   * После вызова triggerBack() приложение выставляет: true = назад обработан (обёртке не вызывать goBack()).
   */
  backWasHandled?: boolean;
  onBackRequest?: () => boolean | void;
}

declare global {
  interface Window {
    RyaskovNativeBridge?: RyaskovNativeBridge;
  }
}
